// datepicker
import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui/ui/i18n/datepicker-zh-TW'

import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/datepicker.css'
import 'jquery-ui/themes/base/theme.css'

// position hack fix
$.extend($.datepicker, { _checkOffset: function (inst, offset, isFixed) { return offset } })



// WEBPACK FOOTER //
// ./src/configs/jquery-ui/index.js